import React, { Component } from 'react';
import { SelectionTool, RectTool, TextTool, ZoomTool, ZoomInTool, ZoomOutTool } from './tools';

class ToolBar extends Component {

  container = null;
  currentTool = null;
  tools = [];
  activeEvents = [];
  toolEvents = [];

  constructor(props) {
    super(props);

    this.tools = {
      selection: (<SelectionTool active={true} />),
      rect: (<RectTool active={false} />),
      text: (<TextTool active={false} />),
      // zoom: (<ZoomTool active={false} />),
      zoomIn: (<ZoomInTool active={false} />),
      zoomOut: (<ZoomOutTool active={false} />),
    }
  }

  setContainer(cont) {
    this.container = cont;
    this.document = this.container.getChild(0);
  }

  getKeyTool(tool) {
    const index = Object.values(this.tools).indexOf(tool);
    if(index > -1)
      return Object.keys(this.tools)[index];
  }

  componentDidMount() {
    Object.keys(this.tools).forEach(key => {
      const ref = this.refs[key];
      ref.setToolBar(this);
      if(!this.toolEvents[key]) {
        this.toolEvents[key] = [];
        if(ref.registerEvents) {
          const events = ref.registerEvents();
          Object.keys(events).forEach(e => {
            this.toolEvents[key].push({name: e, handler: events[e]});
          })
        }
      }
      if(ref.props.active) {
        setTimeout(() => this.setCurrentTool(ref), 0)
      }
      ref.on('click', () => this.setCurrentTool(ref))
    })
  }

  setCurrentTool(tool) {
    this.currentTool = tool;
    Object.keys(this.tools).forEach(k => {
      this.refs[k].setActive(false)
    })
    tool.setActive(true);
    this.updateEvents();
    this.notify('ToolChanged', tool);
  }

  unregisterActiveEvents() {
    const container = this.container.getActualContainer();
    if(this.activeEvents.length) {
      this.activeEvents.forEach(event => container.removeEventListener(event.name, event.handler));
    }
  }

  registerActiveEvents() {
    const container = this.container.getActualContainer();
    if(this.activeEvents.length) {
      this.activeEvents.forEach(event => container.addEventListener(event.name, event.handler));
    }
  }

  updateEvents() {
    this.unregisterActiveEvents();
    const activeTool = this.currentTool;
    this.activeEvents = this.toolEvents[activeTool.name];
    this.registerActiveEvents();
  }

  notify(evt, ...args) {
    if(this.props['on' + evt])
      this.props['on' + evt](...args);
  }

  getTools(toArr) {
    return toArr ? Object.values(this.tools) : this.tools;
  }

  getToolsAsComponents() {
    return Object.values(this.tools).map((tool, index) => {
      return React.cloneElement(tool, {
        ref: Object.keys(this.tools)[index],
        key: index
      });
    });
  }

  getToolComponent(key) {
    const tool = this.refs[key]
    return tool;
  }

  render() {
    return (
      <div className="toolBar">
        {this.getToolsAsComponents()}
      </div>
    );
  }

}

export default ToolBar;



// WEBPACK FOOTER //
// ./src/components/ui/ToolBar.js